export const CONTABILIZEI_API_KEY = 'd1edfbde1f4e42c99c0f39e77ba4197dab9403f2';

// The tenant's `customization.url` still resolves to
// contabilizei.curseduca.pro, which is not the domain buyers know. Pin the
// branded one here instead of trusting the platform config.
export const CONTABILIZEI_PLATFORM_URL =
	'https://plataforma.contabilizeimais.com.br';

export const CONTABILIZEI_REGISTER_PATH = '/contabilizei-mais/register';

// Tells the platform this visitor was bounced off a dead or missing single-use
// link — the client's landing page links straight to this `UNIQUE` checkout
// with no hash. Without the flag the signup page cannot tell a buyer from a
// member who simply opened the signup URL, and a signed-in buyer ends up
// parked in the member area instead of on the checkout.
export const CONTABILIZEI_REGISTER_QUERY = '?checkout=contabilizei';

export const CONTABILIZEI_REGISTER_URL = `${CONTABILIZEI_PLATFORM_URL}${CONTABILIZEI_REGISTER_PATH}${CONTABILIZEI_REGISTER_QUERY}`;
